import React from 'react'
import { Box } from '@workwhile/ui'
import { BillRatesHeader } from './BillRatesHeader'
import { BillRatesFilters } from './BillRatesFilters'
import { BillRatesTable } from './BillRatesTable'

export const BillRatesMain = () => {
  return (
    <>
      <BillRatesHeader />
      <Box margin={3}>
        <BillRatesFilters />
        <BillRatesTable />
      </Box>
    </>
  )
}
